<input
  [formControl]="formControl"
  type="range"
  style="--value-percent-internal: {{ valuePercent }}%"
  #inputEl
  [min]="min"
  [max]="max"
  [step]="step"
  (input)="onInput($event)"
  (change)="onRangeChange($event)"
/>
